var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickBath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.645142,
    y: 0.416016,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#7065F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5054 11.3008C21.6785 11.474 21.7651 11.6813 21.7651 11.9229C21.7651 12.1644 21.6785 12.3672 21.5054 12.5312L14.5054 19.5312C14.3322 19.7044 14.1248 19.791 13.8833 19.791C13.6418 19.791 13.439 19.7044 13.2749 19.5312L9.7749 16.0312C9.60173 15.8672 9.51514 15.6644 9.51514 15.4229C9.51514 15.1813 9.60173 14.974 9.7749 14.8008C9.93896 14.6276 10.1418 14.541 10.3833 14.541C10.6248 14.541 10.8322 14.6276 11.0054 14.8008L13.8901 17.6719L20.2749 11.3008C20.4481 11.1276 20.6554 11.041 20.897 11.041C21.1385 11.041 21.3413 11.1276 21.5054 11.3008Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.45,
    height: 14,
    fill: "white",
    transform: "matrix(1 0 0 -1 9.41516 22.416)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickBath);
export default __webpack_public_path__ + "static/media/tick-bath.b1233ea261286383cc08352fcbc75764.svg";
export { ForwardRef as ReactComponent };